import React from 'react';
import styled from "styled-components";
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { BaseComponent } from '../../../../components/BaseComponent';
import { HBox } from '../../../../components/Box';
import { Trash } from '../../../../components/Icon';
import { deleteCompanyProductCustomization } from '../../actions';
import { Modal, ModalControls } from "../../../../components/Modal";
import { Button } from "../../../../components/Buttons";

const STATE = {
  deleteWarning: false,
};

const ModalContent = styled.div`
    color: black;
`;

class CompanyProductOverviewItemActionsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  renderModalContent() {
    return (
      <ModalContent>
        <p>{this.lbl('product.custom.delete.msg1')}</p>
        <p>{this.props.product.name}</p>
        <p>{this.props.product.vehiclePurpose}</p>
      </ModalContent>
    );
  }

  renderDeleteWarningModal() {
    if (!this.state.deleteWarning) return '';
    return (
      <Modal onClose={() => this.setState({ deleteWarning: false })} title={this.lbl(`invoice.details.warning`)}>
        {this.renderModalContent()}
        <ModalControls>
          <Button onClick={this.props.deleteCustomization}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={() => this.setState({deleteWarning: false })}>
            {this.lbl('cancel')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }

  renderIcons = () => (
      <>
        <HBox vCenter style={{ gap: 10 }}>
          <div
            style={{ cursor: 'pointer', width: '30px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.setState({ deleteWarning: true });
            }}
          >
            <Trash />
          </div>
        </HBox>
        {this.renderDeleteWarningModal()}
      </>
  );

  render() {
    return <>{this.renderIcons()}</>;
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteCustomization() {
      dispatch(deleteCompanyProductCustomization(ownProps?.product.companyId, ownProps?.product.productId, ownProps?.product.id, {}));
    },

  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductOverviewItemActions = compose(withConnect, withRouter)(CompanyProductOverviewItemActionsComp);
